import React from 'react';
import { Apple, Play } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';
import SignUpLink from './SignUpLink';

function StoreBadge({ icon: Icon, top, bottom }) {
  return (
    <button type="button" className="btn-pill flex items-center gap-3 bg-white text-[#0b0b0f] px-5 py-2.5 hover:bg-white/90 transition">
      <Icon size={22} />
      <span className="text-left leading-none">
        <span className="block text-[10px] text-[#6b6b73]">{top}</span>
        <span className="block text-[15px] font-semibold">{bottom}</span>
      </span>
    </button>
  );
}

export default function HowItWorks() {
  const { t } = useI18n();
  const { steps } = useBookersContent();

  return (
    <section className="bg-[#0b0b0f] text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
        <div className="text-center max-w-2xl mx-auto reveal">
          <p className="text-sm font-semibold text-[#a99bff]">{t('howItWorks.eyebrow')}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-3">{t('howItWorks.title')}</h2>
          <p className="text-white/60 mt-4 text-lg">{t('howItWorks.description')}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {steps.map((s, i) => (
            <div key={s.n} className="reveal rounded-3xl bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.07] transition-colors" style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="flex items-center justify-between">
                <span className="h-11 w-11 rounded-xl bg-white/10 flex items-center justify-center">
                  <s.icon size={20} className="text-[#a99bff]" />
                </span>
                <span className="font-display text-4xl text-white/15">{s.n}</span>
              </div>
              <h3 className="font-display text-lg mt-5">{s.title}</h3>
              <p className="text-white/60 mt-2 leading-relaxed text-[14px]">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center gap-5 reveal">
          <p className="text-white/50 text-sm">{t('howItWorks.downloadApp')}</p>
          <div className="flex flex-wrap justify-center gap-3">
            <StoreBadge icon={Apple} top={t('howItWorks.appStoreTop')} bottom={t('howItWorks.appStoreBottom')} />
            <StoreBadge icon={Play} top={t('howItWorks.playStoreTop')} bottom={t('howItWorks.playStoreBottom')} />
          </div>
          <SignUpLink className="btn-pill mt-2 px-7 py-3.5 text-[15px] border border-white/25 text-white hover:bg-white/10 font-semibold transition">
            {t('howItWorks.signUpFree')}
          </SignUpLink>
        </div>
      </div>
    </section>
  );
}
